/**
 * Status column: renders the shared RMA status chip for the list row.
 */
import { observer } from "mobx-react";
import RmaStatusChip from "../../../../../../../components/rma-status-chip/rma-status-chip";
import RmaListItemStore from "../../../../../../../rma-list-page/stores/rma-item-store";
import "./table-column-status.scss";

export interface ITableColumnStatusProps {
    rma: RmaListItemStore;
}

const TableColumnStatus: React.FC<ITableColumnStatusProps> = observer(({ rma }) => {
    return (
        <div className="table-column-status">
            <RmaStatusChip statusKey={rma.statusTranslationKey} />
        </div>
    );
});

export default TableColumnStatus;
